import { useState } from 'react';
import { sortEquipment } from '../helpers';

function VenueCard({ v, eq, canEdit, isAdmin, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="musician-card">
      <div className="musician-card-row" onClick={() => setOpen(o => !o)}>
        <div className="avatar" style={{width:32,height:32,fontSize:12,flexShrink:0}}>{v.name.charAt(0)}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontWeight:700,fontSize:16}}>{v.name}</div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:3}}>
            {v.city&&<span style={{fontSize:16,color:"var(--muted)"}}>{v.city}</span>}
            {eq.length>0&&<span style={{fontSize:16,color:"var(--muted)"}}>{eq.length} attrezzature</span>}
          </div>
        </div>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          style={{flexShrink:0,marginLeft:6,transition:"transform .2s",transform:open?"rotate(180deg)":"rotate(0deg)"}}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {open&&<div className="musician-card-expand">
        {v.address&&<div style={{fontSize:16,color:"var(--muted)",marginBottom:6}}>{v.address}</div>}
        {v.description&&<div style={{fontSize:16,color:"var(--text)",marginBottom:8,lineHeight:1.6}}>{v.description}</div>}
        {eq.length>0&&<>
          <div style={{fontSize:16,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".7px",marginBottom:6}}>Attrezzatura</div>
          <div className="chip-group" style={{marginBottom:8}}>
            {sortEquipment(eq).map(e=><span key={e.item} className="chip" style={{fontSize:16,background:"rgba(237,77,29,.08)",borderColor:"rgba(237,77,29,.25)",color:"var(--text)"}}>
              {e.item}
            </span>)}
          </div>
        </>}
        {v.email&&<div style={{fontSize:16,color:"var(--muted)",marginBottom:4}}>{v.email}</div>}
        {canEdit&&<div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>
          <button className="btn btn-xs btn-secondary" onClick={e=>{e.stopPropagation();onEdit();}}>Modifica</button>
          {isAdmin&&<button className="btn btn-xs btn-danger" onClick={e=>{e.stopPropagation();onDelete();}}>Elimina</button>}
        </div>}
      </div>}
    </div>
  );
}

export default VenueCard;
